import { ClaimEditor, ClaimEditorStore } from '@enter/core';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { IInjectedRootStore } from 'stores';

interface IProviderClaimEditorProps extends IInjectedRootStore {}

export const ProviderClaimEditor: React.FunctionComponent<IProviderClaimEditorProps> = inject('rootStore')(
    observer((props: IProviderClaimEditorProps) => {
        const { claimId } = useParams<{ claimId: string }>();
        const navigate = useNavigate();
        const location = useLocation();
        const { rootStore } = props;

        // Check if template query parameter is present
        const searchParams = new URLSearchParams(location.search);
        const isTemplate = searchParams.get('template') === 'true';

        if (!rootStore) {
            return null;
        }

        const handleSuccess = (newClaimId: string) => {
            // Provider-specific navigation after successful submission
            navigate(`/claims/${newClaimId}`);
        };

        const handleCancel = () => {
            navigate(-1);
        };

        return (
            <ClaimEditor
                claimEditorStore={rootStore.claimEditorStore}
                claimId={claimId}
                isTemplate={isTemplate}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
            />
        );
    }),
);
